module.exports = __webpack_public_path__ + "img/设备.9b32db5e.gif";